import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  UIUXIcon,
  CMSIcon,
  EcommerceIcon,
  LaravelIcon,
  WebPortIcon,
  ContentIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: UIUXIcon,
    title: "UI/UX Design",
    description:
      "As a top-class website development company in UK, we specialise in the art of crafting engaging user interfaces and delivering outstanding user experiences. Our web design company goes beyond the ordinary, starting with thorough Information Architecture (IA) strategising, detailed wireframe design, and the creation of visually stunning layouts. Apart from an appealing visual impact, our websites also offer an intuitive and delightful journey for users.",
  },
  {
    icon: CMSIcon,
    title: "Website Development with CMS",
    description:
      "You can have the most suitable Content Management System (CMS) to meet your website's demands. Our web developers in UK are experts in website development using well-known CMS platforms like WordPress, Drupal, and Webflow. Whether you require a dynamic blog or a corporate website, we customise our CMS solutions to precisely align with your unique requirements.",
  },
  {
    icon: EcommerceIcon,
    title: "E-commerce Development",
    description:
      "Elevate your business to a successful online store utilising our premium services in e-commerce development. As a distinguished web development company in the UK, we strongly focus on crafting web-based stores utilising Shopify, WooCommerce, or BigCommerce. Our web design services are meticulously aligned to enhance your online sales and offer your customers a smooth and satisfying shopping journey.",
  },
  {
    icon: LaravelIcon,
    title: "Laravel Web Development",
    description:
      "Our skilled Laravel developers employ robust development techniques to conceptualise and construct web-based products that adhere to industry norms. With a commitment to delivering high-quality web development services, our professionals are firm in their mission to offer clients scalable business solutions that drive improvements in profitability, and overall productivity.",
  },
  {
    icon: WebPortIcon,
    title: "Web App or Web Portal Development",
    description:
      "Scale up your business through our tailored Web App and Web Portal development services. Whether you require an internal tool for optimising your process or you're embarking on launching a Software as a Service (SaaS) product, our website development company is ready to create web-based applications customised to your specific needs.",
  },
  {
    icon: ContentIcon,
    title: "Content Development",
    description:
      "The content on your website serves as the authentic voice of your brand. We engage in a collaborative process with your team to gain a deep understanding of your business niche and craft a tailored content strategy. From compelling written content to visually appealing elements, our content marketers and web designers ensure that your online presence eloquently conveys the narrative and principles of your brand.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section uk-web-services p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={9}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              TekRevol’s <span>Web Design and Development</span> Services
            </h2>
            <p className="impro_para">
              If you are looking for something more than just an online
              presence, TekRevol is here to facilitate you with exceptional
              website design and development service as a whole package. A
              website that attracts users with its vibrant design and enables
              them to convert based on the rich features. Our{" "}
              <Link to="/uk">UK-based digital transformation agency</Link> has
              diverse expertise to offer different web solutions that you can
              acquire based on your business requirements.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto mt-3">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div
                  className="stack_item"
                  key={index}
                  style={{ pointerEvents: "none" }}
                >
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
